import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource, MatSort, Sort, PageEvent} from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { OapHtmlDownloadFile } from 'src/app/helpers/oap-html-download-file';
import { PaginationDataModel } from 'src/app/models/pagination-data.model';
import { errorMessages, OapErrorMessages, OapStandarErrorStateMatcher } from 'src/app/modules/custom-validators/custom-validators.module';
import { AlertService } from 'src/app/services/alert.service';
// tslint:disable-next-line:max-line-length
import { ColumnDefinition, PredefinedQueryRequest, VariablesRequest, PredefinedQueryVariable, QueryResultatsResponse, PredefinedQuery, PredefinedQueryDetail } from '../../predefined-queries.models';
import { PredefinedQueriesService } from '../../predefined-queries.service';

@Component({
  selector: 'oap-predefined-query-results',
  templateUrl: './predefined-query-results.component.html',
  styleUrls: ['./predefined-query-results.component.scss']
})
export class PredefinedQueryResultsComponent implements OnInit {

  panelOpenState = false;

  queryKeyRequested: string;
  queryVariables: PredefinedQueryVariable[] = [];

  columns: ColumnDefinition[] = [];
  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<Object>;
  @ViewChild(MatSort) sort: MatSort;

  rows: Object[] = [];
  loading = false;
  showFormVariables = false;
  noData = false;

  selectedRowIndex = -1;

  viewButtonExport = false; // autorise la vue du boutton export excel

  dynamicForm: FormGroup;
  dynamicFormArray: FormArray[];
  submitted = false;

  predefinedQueryRequest: PredefinedQueryRequest;

  matcher = new OapStandarErrorStateMatcher();
  errors = errorMessages;
  validation_messages = OapErrorMessages;

  showResults = false;
  startRequest = false;

  informations = '';

  withVariables = false;
  queryPaginated!: boolean;
  metaData?: PaginationDataModel;
  selectedQuery: PredefinedQuery;
  blockedExportExcel = false;
  btnExcelLabel = 'Exporter le résultat vers excel';

  constructor(private _router: Router,
    private alertService: AlertService,
    private _route: ActivatedRoute,
    private _predefinedQueriesService: PredefinedQueriesService,
    private oapHtmlDownloadFile: OapHtmlDownloadFile,
    private formBuilder: FormBuilder) { }

  ngOnInit() {

    this.queryKeyRequested = this._route.snapshot.paramMap.get('queryKey');
    // console.log('queryKey requested: ' + this.queryKeyRequested);

    if (this.queryKeyRequested) {

      this._predefinedQueriesService.getQueryDetail(this.queryKeyRequested)
      .subscribe(
        response =>  {
          this.selectedQuery = response;
          this.queryPaginated = this.selectedQuery.paginated;

          if (this.queryPaginated) {
            this.metaData = new PaginationDataModel();
            this.metaData.currentPage = 1;
            this.metaData.pageSize = 10;
            this.metaData.totalElements = 10;
            this.metaData.totalPages = 1;
          }

          if (this.selectedQuery.withVariables) {
            this.queryVariables = this.selectedQuery.variables;
            this.showFormVariables = true;
            this.dynamicForm = this.formBuilder.group({
              variables: new FormArray([])
            });
            this.buildForm();
          } else {
            this.alertService.clear();
            const queryKey: number = Number(this.queryKeyRequested);
            this.predefinedQueryRequest = new PredefinedQueryRequest();
            this.predefinedQueryRequest.queryKey = queryKey;
            this.predefinedQueryRequest.variables = null;
            this.executeQuery(this.predefinedQueryRequest, true);
          }
        }
      );
    }
  }

  // convenience getters for easy access to form fields
  get f() { return this.dynamicForm ? this.dynamicForm.controls : null; }
  get t() { return this.f ? this.f.variables as FormArray : null; }

  buildForm() {
    if (this.queryVariables.length > 0) {
      for (let i = 0; i < this.queryVariables.length; i++) {
        if (this.queryVariables[i].required) {
          this.t.push(this.formBuilder.group({
            variable: ['', Validators.required]
          }));
        } else {
          this.t.push(this.formBuilder.group({
            variable: ['']
          }));
        }
      }
    }
  }

  onSubmit() {
    this.submitted = true;
    this.alertService.clear();
    this.showResults = false;

    // stop here if form is invalid
    if (this.dynamicForm.invalid) {
        return;
    }

    const values = this.dynamicForm.value;
    const queryKey: number = Number(this.queryKeyRequested);
    this.predefinedQueryRequest = new PredefinedQueryRequest();
    this.predefinedQueryRequest.queryKey = queryKey;
    const variables: VariablesRequest[] = [];
    for (let i = 0; i < values.variables.length; i++) {
      const value = values.variables[i].variable;
      const variable: VariablesRequest = {
        requeteVariableKey: this.queryVariables[i].requeteVariableKey,
        name: this.queryVariables[i].variable.codeSubstitution ,
        value: value ? value : null
      };
      variables.push(variable);
    }
    this.predefinedQueryRequest.variables = variables;

    this.executeQuery(this.predefinedQueryRequest, true);
  }

  executeQuery(predefinedQueryRequest, showLoading: boolean) {
    this.loading = showLoading;
    this.columns = [];
    this.displayedColumns = [];
    this.rows = [];

    const currentPage = this.metaData === undefined ? undefined : this.metaData.currentPage;
    const pageSize = this.metaData === undefined ? undefined : this.metaData.pageSize;

    this._predefinedQueriesService.executeQueryWithVariable(predefinedQueryRequest, currentPage, pageSize)
      .subscribe(
        response => {
          this.showResults = true;
          this.displayResults(response);
          if (response.metaData !== undefined && this.metaData !== undefined) {
            this.metaData = response.metaData;
          }
        },
        error => {
          console.error(error);
          this.loading = false;
          this.alertService.error(error, true);
        },
        () => { this.loading = false;  }
      );
  }

  displayResults(data: QueryResultatsResponse) {
    if (data.columnList === null) {
      this.loading = false; this.viewButtonExport = false;
      this.noData = true;
    } else {
      this.noData = false;

      data.columnList.forEach(dataObject => {
        const columnDefinition: ColumnDefinition = {name: dataObject.name, type: dataObject.type };
        this.columns.push(columnDefinition);
        this.displayedColumns.push(dataObject.name);
      });

      // console.log(this.displayedColumns);

      let obj = {};
      data.valueList.forEach(dataObject => {
        for (let i = 0; i < dataObject.length; i++) {
          obj[this.displayedColumns[i]] = dataObject[i];
        }
        this.rows.push(obj);
        obj = {};
      });
      this.dataSource = new MatTableDataSource<Object>(this.rows);
      this.viewButtonExport = true;
    }
  }

  onSortData(sort: Sort) {
    this.sortData();
  }

  private sortData() {
    if (!this.dataSource) {
      return;
    }

    const data = this.dataSource.data;

    let sort: Sort = {
      active: this.sort.active,
      direction: this.sort.direction
    };

    if (!sort.active || sort.direction === '') {
      // tri par défaut
      sort = {
        active: '',
        direction: ''
      };
    }

    this.dataSource = new MatTableDataSource(data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return compare(a[sort.active], b[sort.active], isAsc);
    }));
  }

  exportExcel() {
    this.blockedExportExcel = true;
    this.btnExcelLabel = 'Export en cours...';

    const queryKey: number = Number(this.queryKeyRequested);
    let exportPredefinedQuery: PredefinedQueryRequest;
    if ( this.predefinedQueryRequest) {
      exportPredefinedQuery = this.predefinedQueryRequest;
    } else {
      exportPredefinedQuery = { queryKey : queryKey, variables : null };
    }

    this._predefinedQueriesService.exportExcel(exportPredefinedQuery)
      .subscribe(
        data => {
          const blob = new Blob([data.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const nomDoc = data.headers.get('oap-export-file-name');
          this.oapHtmlDownloadFile.downloadFileOnNavigator(blob, nomDoc, true);
        },
        error => {
          console.error(error);
        },
        () => {
          this.loading = false;
          this.blockedExportExcel = false;
          this.btnExcelLabel = 'Exporter le résultat vers excel';
        }
      );
  }

  onPageEvent(event: PageEvent) {
    if (this.metaData !== undefined) {
      this.metaData.currentPage = event.pageIndex + 1;
      this.metaData.pageSize = event.pageSize;

      const queryKey: number = Number(this.queryKeyRequested);
      let exportPredefinedQuery: PredefinedQueryRequest;
      if ( this.predefinedQueryRequest) {
        exportPredefinedQuery = this.predefinedQueryRequest;
      } else {
        exportPredefinedQuery = { queryKey : queryKey, variables : null };
      }
      this.executeQuery(exportPredefinedQuery, false);
    }
  }

}

function compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
